import { render, staticRenderFns } from "./NSSIList.vue?vue&type=template&id=dca0e5b6&"
import script from "./NSSIList.vue?vue&type=script&lang=js&"
export * from "./NSSIList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports